import { useFormContext } from 'react-hook-form'
import { CheckboxField } from '@hashicorp/react-mds/src/components/form/checkbox'
import FieldWrapper from '../../field-wrapper'
import { formattedLabel, useErrorMessage } from '../../../utils'
import type { MarketoFormCheckboxField } from '../../../types'

const MarketoFormCheckboxField = ({
	field,
}: {
	field: MarketoFormCheckboxField
}) => {
	const {
		register,
		watch,
		formState: { isSubmitSuccessful, isSubmitting },
	} = useFormContext()
	const error = useErrorMessage(field.id)
	const checked = watch(field.id, false)

	return (
		<FieldWrapper fieldId={field.id}>
			<CheckboxField
				label={formattedLabel(field)}
				field={{
					...register(field.id),
					checked,
					disabled: isSubmitting || isSubmitSuccessful,
				}}
				error={error}
			/>
		</FieldWrapper>
	)
}

export default MarketoFormCheckboxField
